import React from "react";
import { Helmet } from "react-helmet";

const Newpaper = () => {
  const pageTitle = "Alcohol Free Sanitizer & Diabetic Ulcer | Ardor in News";
  const pageDescription =
    "Discover how Ardor Biomed’s Alcohol Free Sanitizer is making headlines for safe hygiene and diabetic ulcercare. Featured in top newspapers and media.";
  const pageUrl = "https://ecom.vishushethra.com/Newpaper";
  const featuredImage = "https://ecom.vishushethra.com/assets/img/logo-3.png";
  return (
    <>
      <Helmet>
        {/* Primary Meta Tags */}
        <title>{pageTitle}</title>
        <meta name="description" content={pageDescription} />
        <link rel="canonical" href={pageUrl} />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content={pageTitle} />
        <meta property="og:description" content={pageDescription} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={pageUrl} />
        <meta property="og:image" content={featuredImage} />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:site_name" content="Ardor Biomed" />
        <meta property="og:locale" content="en_US" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={pageTitle} />
        <meta name="twitter:description" content={pageDescription} />
        <meta name="twitter:image" content={featuredImage} />
        <meta name="twitter:site" content="@ardorbiomed" />
        <meta name="twitter:creator" content="@ardorbiomed" />

        {/* Schema.org JSON-LD */}
        <script type="application/ld+json">
          {`
                {
                  "@context": "https://schema.org",
                  "@type": "BlogPosting",
                  "headline": "${pageTitle}",
                  "description": "${pageDescription}",
                  "url": "${pageUrl}",
                  "image": "${featuredImage}",
                  "author": {
                    "@type": "Organization",
                    "name": "Ardor Biomed"
                  },
                  "publisher": {
                    "@type": "Organization",
                    "name": "Ardor Biomed",
                    "logo": {
                      "@type": "ImageObject",
                      "url": "https://ecom.vishushethra.com/logo.png"
                    }
                  },
                  "datePublished": "2023-11-15",
                  "mainEntityOfPage": {
                    "@type": "WebPage",
                    "@id": "${pageUrl}"
                  }
                }
              `}
        </script>
      </Helmet>
      <div></div>
    </>
  );
};

export default Newpaper;
